import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=2b955bdc&scoped=true&"
import script from "./msg.vue?vue&type=script&lang=js&"
export * from "./msg.vue?vue&type=script&lang=js&"
import style0 from "./msg.vue?vue&type=style&index=0&id=2b955bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b955bdc",
  null
  
)

export default component.exports